import { DragMoveEvent } from '@dnd-kit/core';
import {
  DropType,
  IColumnDropPosition,
  IGridDropPosition,
  IGridPosition,
  IRowDropPosition,
} from './types';
import { MaybeNil } from '../../utils/interfaces';
import { isNil } from 'lodash';
import { z } from 'zod';
import { ZodProperties } from '../../utils/zod';
import { ENTIRE_GRID_DROPPABLE_ID } from './constants';

export const getClosestCollision = (
  collisions: DragMoveEvent['collisions'],
) => {
  if (collisions && collisions.length) {
    const filteredCollisions = collisions.filter(
      (c) => c.id !== ENTIRE_GRID_DROPPABLE_ID,
    );
    if (filteredCollisions.length) {
      return filteredCollisions[0];
    }
  }
  return null;
};

export const arePositionsEqual = (
  a: MaybeNil<IGridPosition>,
  b: MaybeNil<IGridPosition>,
) => {
  if (!isNil(a) && !isNil(b)) {
    return a.rowIndex === b.rowIndex && a.colIndex === b.colIndex;
  }

  return false;
};

export const areDropPositionsEqual = (
  a: MaybeNil<IGridDropPosition>,
  b: MaybeNil<IGridDropPosition>,
) => {
  if (!isNil(a) && !isNil(b)) {
    if (a.type === DropType.COLUMN && b.type === DropType.COLUMN) {
      return arePositionsEqual(a, b);
    } else if (a.type === DropType.ROW && b.type === DropType.ROW) {
      return a.rowIndex === b.rowIndex;
    }
  }

  return false;
};

export const GridPositionSchema = z.object<ZodProperties<IGridPosition>>({
  rowIndex: z.number().nonnegative(),
  colIndex: z.number().nonnegative(),
});

const GridDropPositionSchema = z
  .object<ZodProperties<IRowDropPosition>>({
    type: z.literal(DropType.ROW),
    rowIndex: z.number().nonnegative(),
  })
  .or(
    z.object<ZodProperties<IColumnDropPosition>>({
      type: z.literal(DropType.COLUMN),
      rowIndex: z.number().nonnegative(),
      colIndex: z.number().nonnegative(),
    }),
  );

export const CollisionDescriptorSchema = z.object({
  data: z.object({
    // closestEdge: z.nativeEnum(Edge),
    droppableContainer: z.object({
      data: z.object({
        current: GridDropPositionSchema,
      }),
    }),
  }),
});
